import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";

import config from "@/config";
import log from "@/helpers/log";
import { NOTIFICATION_MODULE_KEY, NotificationDetails } from "@/utils/enums";
import store from "@/vuexStore";

import { authGet, authPatch } from "../authStoreRequest";

// @ts-expect-error decorator is picking the wrong overload as its type
@Module({
  namespaced: true,
  name: NOTIFICATION_MODULE_KEY,
  store,
  dynamic: true,
})
class NotificationModule extends VuexModule {
  notifications: NotificationDetails[] = [];

  public get newNotifications() {
    return this.notifications.length > 0 ? this.notifications.filter((item: { is_read: boolean }) => !item.is_read) : [];
  }

  public get getNotifications() {
    return this.notifications.length > 0 ? this.notifications : [];
  }

  @Action
  async fetchUserNotifications() {
    try {
      const response = await authGet(`${config.backendURL}/user-notifications`, {}, {});
      const { notifications } = response as { notifications: NotificationDetails[] };
      this.setNotifications(notifications);
    } catch {
      // log.error("error when getting notifications", error);
    }
  }

  @Action
  async markNotificationsAsRead(notificationIds: number[]) {
    // only process notifications that are unread
    const validNotificationIds = notificationIds.filter(
      (id: number) => this.notifications.findIndex((item: { ID: number; is_read: boolean }) => item.ID === id && !item.is_read) > -1
    );
    if (validNotificationIds.length === 0) {
      return;
    }
    try {
      const requestParameters = { notification_ids: validNotificationIds };
      await authPatch(`${config.backendURL}/user-notifications`, requestParameters, {});
      this.updateNotifications({ notificationIds: validNotificationIds, isRead: true });
    } catch (error) {
      log.error("error when marking notifications as read", error);
    }
  }

  @Action
  async fetchNotificationLastSeen() {
    try {
      const response = await authGet(`${config.backendURL}/user-notifications/last-seen`, {}, {});
      const { last_seen_at } = response as { last_seen_at: string };
      return last_seen_at;
    } catch (error) {
      log.error("error when getting notification last seen", error);
      return null;
    }
  }

  @Action
  async updateNotificationLastSeen() {
    try {
      await authPatch(`${config.backendURL}/user-notifications/last-seen`, {}, {});
    } catch (error) {
      log.error("error when updating notification last seen", error);
    }
  }

  @Mutation
  updateNotifications({ notificationIds, isRead }: { notificationIds: number[]; isRead: boolean }) {
    notificationIds.forEach((id: number) => {
      const idx: number = this.notifications.findIndex((item: { ID: number }) => item.ID === id);
      const newItem = { ...this.notifications[idx], is_read: isRead };
      this.notifications.splice(idx, 1, newItem);
    });
  }

  @Mutation
  public setNotifications(items: NotificationDetails[]) {
    this.notifications = items;
  }
}

const notificationModule = getModule(NotificationModule);

export default notificationModule;
